import React, { useContext } from 'react';
import { Col, Row, Spin } from 'antd';

import ContactSearchContainer from '@totem/components/contactSearch/contactSearchContainer';
import SearchResultsTable from '@totem/components/contactSearch/SearchResultsTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserDataPermissions from '@totem/components/users/details/UserDataPermissions';
import UserDetailsContext from '@totem/components/users/details/UserDetailsContext';
import UserProfileCard from '@totem/components/users/details/UserProfileCard';
import UserSecurityGroups from '@totem/components/users/details/UserSecurityGroups';
import { Breadcrumb } from '@totem/types/breadcrumb';

const UserDetailsLayout = () => {
  const { user, userLoading } = useContext(UserDetailsContext);

  const getBreadcrumbs = (breadcrumbsIn: Breadcrumb) => {
    const crumbs = [breadcrumbsIn];
    crumbs.push({ label: 'Users', link: '/dashboard/usermanagement' });

    crumbs.push({ label: user ? user.email : 'User Details' });
    return crumbs;
  };

  if (userLoading || !user) {
    return (
      <ContentLayout breadcrumbs={(crumbs) => getBreadcrumbs(crumbs[0])}>
        <div
          style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}
        >
          <Spin size="large" />
        </div>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout breadcrumbs={(crumbs) => getBreadcrumbs(crumbs[0])}>
      <UserProfileCard />
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} xl={12}>
          <UserSecurityGroups />
        </Col>
        <Col xs={24} xl={12}>
          <UserDataPermissions />
        </Col>
      </Row>
      <div style={{ marginTop: 16 }}>
        <IBCard isCovered title={'Contacts'}>
          <ContactSearchContainer defaultSearchTerm={user.email}>
            <SearchResultsTable />
          </ContactSearchContainer>
        </IBCard>
      </div>
    </ContentLayout>
  );
};

export default UserDetailsLayout;
